import { useContext } from 'react'
import { SsrContext } from '@app/util/contexts/SsrContext'

/** Marks the current SSR response status (e.g. 404). No-op on the client. */
export const useReportHttpStatus = (code: number): void => {
  const { httpStatusRef } = useContext(SsrContext)
  if (httpStatusRef) {
    httpStatusRef.code = code
  }
}
